import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';

type WidgetProps = {
  title: string;
  textPrimary: string | number;
  textSecondary?: string;
  description: string;
};

export const Widget = ({
  title,
  textPrimary: content,
  textSecondary: subcontent,
  description,
}: WidgetProps) => {
  return (
    <Card className="h-full justify-between p-4 shadow-md">
      <CardHeader className="p-0">
        <CardTitle className="text-sm">{title}</CardTitle>
      </CardHeader>

      <CardContent className="flex-row items-baseline gap-2 p-0">
        <span className="text-2xl font-bold text-primary">{content}</span>
        {subcontent && (
          <span className="text-xs text-muted-foreground">{subcontent}</span>
        )}
      </CardContent>

      <CardDescription className="mt-1 text-[0.72rem] leading-tight">
        {description}
      </CardDescription>
    </Card>
  );
};
